import { render } from "./CustomerStatisticsView.vue?vue&type=template&id=768525fd&scoped=true"
import script from "./CustomerStatisticsView.vue?vue&type=script&lang=js"
export * from "./CustomerStatisticsView.vue?vue&type=script&lang=js"

import "./CustomerStatisticsView.vue?vue&type=style&index=0&id=768525fd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768525fd"]])

export default __exports__